<template>
  <div class="menu clear-fix">
    <!-- <div class="menu-item button" @click="goStoreclass">
      <i class="iconfont">
        <img class="menu-item-icon" src="../../../assets/image/home/icon_shop_classify_pre.png" />
        <img class="menu-item-icon" src="../../../assets/image/home/1.png" />
      </i>
      <span class="menu-item-title">Store</span>
    </div> -->
    <div class="menu-item button" @click="goBrand">
      <i class="iconfont">
        <!-- <img class="menu-item-icon" src="../../../assets/image/home/icon_brand_name_pre.png" /> -->
        <img class="menu-item-icon" src="../../../assets/image/member/m1.png" />
      </i>
      <span class="menu-item-title">{{ $t('MyWallet') }}</span>
    </div>
    <div class="menu-item button" @click="goFavorite">
      <i class="iconfont">
        <img class="menu-item-icon" src="../../../assets/image/member/m7.png" />
      </i>
      <span class="menu-item-title">{{ $t('BlindBox') }}</span>
    </div>
    <!-- <div class="menu-item button" @click="goPintuan">
      <i class="iconfont"><img class="menu-item-icon" src="../../../assets/image/home/icon_top_round_pre.png" /></i>
      <span class="menu-item-title">拼团</span>
    </div>
    <div class="menu-item button" @click="goBargain">
      <i class="iconfont"><img class="menu-item-icon" src="../../../assets/image/home/icon_top_bargain_pre.png" /></i>
      <span class="menu-item-title">砍价</span>
    </div>
    <div class="menu-item button" @click="goMemberPointSignin">
      <i class="iconfont"><img class="menu-item-icon" src="../../../assets/image/home/icon_top_signin_pre.png" /></i>
      <span class="menu-item-title">签到</span>
    </div> -->
    <!-- <div class="menu-item button">
      <i class="iconfont"><img class="menu-item-icon" @click="$router.push({ name: 'HomeGoodslist', query: { xianshi: 1 } })"
          src="../../../assets/image/home/icon_top_discount_pre.png" /></i>
      <span class="menu-item-title">秒杀</span>
    </div>
    <div class="menu-item button" @click="goPointsgoods">
      <i class="iconfont"><img class="menu-item-icon" src="../../../assets/image/home/icon_top_cumulative_pre.png" /></i>
      <span class="menu-item-title">积分商城</span>
    </div> -->
    <div class="menu-item button" @click="goConsultList">
      <i class="iconfont ">
        <img class="menu-item-icon" src="../../../assets/image/member/m5.png" />
      </i>
      <span class="menu-item-title">{{ $t('GiftCard') }}</span>
    </div>
    <div class="menu-item button" @click="getEmail">
      <i class="iconfont">
        <img class="menu-item-icon" src="../../../assets/image/member/m11.png" />
      </i>
      <span class="menu-item-title">{{ $t('Contact us') }}</span>
    </div>
    <!-- <div class="menu-item button" @click="goMemberIndex">
      <i class="iconfont bg-2">&#xe68c;</i>
      <span class="menu-item-title">个人中心</span>
    </div> -->
    <!-- <div class="menu-item button" @click="goGroupBuy">
      <i class="iconfont"><img class="menu-item-icon" src="../../../assets/image/home/icon_top_knock_pre.png" /></i>
      <span class="menu-item-title">抢购</span>
    </div>
    <div class="menu-item button" @click="goPresell">
      <i class="iconfont"><img class="menu-item-icon" src="../../../assets/image/home/icon_top_yushou_pre.png" /></i>
      <span class="menu-item-title">预售</span>
    </div> -->
    <div class="menu-item button" v-for="(item, index) in navs" :key="index" @click="goAdUrl(item)">
      <i class="iconfont"><img class="menu-item-icon" :src="item.adv_code" /></i>
      <span class="menu-item-title">{{ item.adv_title }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'HomeMenu',
  props: ['items'],
  computed: {
    ...mapState({
      isOnline: state => state.member.isOnline,
      navs: state => state.home.navs
    })
  },
  methods: {
    getEmail() {
      this.$router.push({ name: 'MemberContactUs' })
    },
    showLogin() {
      this.$router.push({ name: 'HomeMemberLogin' })
    },
    goPointsgoods() {
      this.$router.push({ 'name': 'HomePointsgoods' })
    },
    goStoreclass() {
      // this.$router.push({ 'name': 'HomeStoreclass' })
      this.$router.push({ 'name': 'HomeGoodsclass' })
    },
    goPintuan() {
      this.$router.push({ 'name': 'HomePintuanList' })
    },
    goBargain() {
      this.$router.push({ 'name': 'HomeBargainlist' })
    },
    goBrand() {
      this.$router.push({ 'name': 'MemberAccount' })
    },
    goFavorite() {
      this.$router.push({ 'name': 'BlindBoxList' })
    },
    goArticleclass() {
      this.$router.push({ 'name': 'HomeArticleclass' })
    },
    goConsultList() {
      this.$router.push({ 'name': 'GiftBoxList' })
    },
    goMemberIndex() {
      this.$router.push({ 'name': 'MemberIndex' })
    },
    goGroupBuy() {
      this.$router.push({ 'name': 'HomeGroupBuyList' })
    },
    goPresell() {
      this.$router.push({ 'name': 'HomePresellList' })
    },
    goMemberPointSignin() {
      this.$router.push({ 'name': 'MemberPointSignin' })
    },
    myOrder() {
      if (this.isOnline) {
        this.$router.push({
          name: 'GiftSave'
        })
      } else {
        this.showLogin()
      }
    },
    goAdUrl(item) {
      this.$router.push({ path: item.adv_typedate })
    }
  }
}
</script>

<style lang="scss" scoped>
.menu {
  overflow: hidden;
  justify-content: space-around;
  background: #FFFFFF;
  box-sizing: border-box;
  padding-left: .7rem;
  padding-right: .7rem;
  margin: $modelSpace 0;
  display: flex;

  .menu-item {
    width: 20%;
    padding: 0 .7rem;
    padding-bottom: 20%;
    height: 0;
    box-sizing: border-box;
    text-align: center;
    position: relative;
    float: left;

    .iconfont {
      position: absolute;
      margin: auto;
      top: 0;
      bottom: 1.4rem;
      left: .7rem;
      right: .7rem;
      font-size: 0;
      color: #fff;
      overflow: hidden;
      display: block;
      text-align: center;
    }

    .menu-item-icon {
      width: 90%;
      height: 90%;
      overflow: hidden;
    }

    .menu-item-title {
      position: absolute;
      left: 0;
      right: 0;
      bottom: .6rem;
      display: block;
      color: $formInputColor;
      font-size: $fontSize;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.bg-1 {
  background-image: linear-gradient(to bottom, #d69dcc, #e8198b);
}

.bg-2 {
  background-image: linear-gradient(to bottom, #04befe, #4481eb);
}

.bg-3 {
  background-image: linear-gradient(to bottom, #cc208e, #6713d2);
}

.bg-4 {
  background-image: linear-gradient(to bottom, #ff9a44, #fc6076);
}

.bg-5 {
  background-image: linear-gradient(to bottom, #00ecbc, #007adf);
}

.bg-6 {
  background-image: linear-gradient(to bottom, #ff8177, #b12a5b);
}
</style>
